import { DropdownOptions } from 'ia-react-core';
import { useLocation } from 'react-router-dom';

export default function useDefaultValue<T>(name: string, options: DropdownOptions<T>, required = true, overridenKey: string = null): T {
  const { search } = useLocation();
  const defaultKey = new URLSearchParams(search).get(name);
  let defaultValue = options.filter((x) => {
    const key2Use = overridenKey === null ? x.key : overridenKey;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line eqeqeq, @typescript-eslint/no-unsafe-member-access
    return (key2Use ? x.value[key2Use] : x.value) == defaultKey;
  })[0]?.value;
  if (!defaultValue && required && options.length === 1) {
    defaultValue = options[0].value;
  }
  return defaultValue;
}
